import {AfterViewInit, Component} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {BaseFeatureWelcomeComponent} from '@catapp/shared/feature/create-form-wizards/base-feature-welcome.component';
import {FeatureTypeService} from '@catcore/services';
import {linkedResourceToGenericEmbeddedResource} from '@catcore/utils/json-resources';
import {FeatureGgwImplementationsService} from '@catmodules/models/feature-ggw-implementations/services/feature-ggw-implementations.service';
import {GgwImplementationsService} from '@catmodules/models/ggw-implementations/services/ggw-implementations.service';
import {SelectItem} from 'primeng/primeng';
import {isNullOrUndefined} from 'util';
import {FeatureGgwDevicesService} from "@catmodules/models/ggw-device/services/feature-ggw-devices.service";
import {GgwDevicesService} from "@catmodules/models/ggw-device/services/ggw-devices.service";
import {sortByLabelFunc} from "@catcore/utils";

/**
 * A component to fast create a new FeatureGgwImplementation for the currently used Feature
 *
 * A new FeatureGgwImplementation inherits the some properties of its linked GgwImplementation.
 *
 * This properties are:
 * - name
 */
@Component({
    templateUrl: './feature-ggw-device-landing.component.html',
})
export class FeatureGgwDeviceLandingComponent
    extends BaseFeatureWelcomeComponent
    implements AfterViewInit {

    ggwDeviceOptions: SelectItem[];
    featureUnitsOptions: SelectItem[];
    resetAfterComplete = true;

    unitRequired = false;

    /**
     * The self-name to be used throughout the displayed elements.
     * Reference to the current used type of model
     * @type {string}
     */
    selfLabel = 'Feature GGW Device';

    /**
     * The title used by the form wizard component
     * @type {string}
     */
    title = `New ${this.selfLabel}`;

    /**
     * Label names to be used by form input elements.
     * @type {{ggwImplementations: string; name: string; featureUnits: string; dropdownPlaceholder: string; buttons: {last: string}}}
     */
    labels = {
        ggwDevices: 'GGW Devices',
        name: 'Name',
        featureUnits: 'Feature Units',
        dropdownPlaceholder: 'Select one',
        buttons: {last: `Save the ${this.selfLabel}`},
    };

    /**
     * Returns true if the current form object is ready.
     * Ready means all necessary data that is required to display and use the form, is available
     * @returns {boolean}
     */
    get formIsReady() {
        let isReady = !isNullOrUndefined(this.feature);
        isReady = isReady && !isNullOrUndefined(this.form);
        isReady = isReady && !isNullOrUndefined(this.featureUnitsOptions);
        isReady = isReady && !isNullOrUndefined(this.ggwDeviceOptions);
        return isReady;
    }

    constructor(private ggwDevicesService: GgwDevicesService,
                private featureGgwDevicesService: FeatureGgwDevicesService,
                featureService: FeatureTypeService) {

        super(featureService);

        this.form = new FormGroup({
            ggwDevice: new FormControl('', [Validators.required]),
            featureUnit: new FormControl('', [Validators.required]),
            name: new FormControl('', []),
        });
    }

    beforeDisplayProperties() {
        this
            .ggwDevicesService
            .getAll().subscribe((services: any[]) => {
            this.updateGgwDeviceOptions(services);
        });
    }

    afterFeatureChanged(feature: any) {
        if (!isNullOrUndefined(feature) && !isNullOrUndefined(feature._links.unit_types)) {
            this.updateFeatureUnitOptions(feature._links.unit_types);
        } else {
            this.updateFeatureUnitOptions([]);
        }
    }

    validatePropertiesView() {
    }

    /**
     * Executes the request to create a new FeatureGgwImplementation
     *
     */
    saveNewEntity() {

        this.featureGgwDevicesService
            .create({
                feature: this.feature,
                featureUnit: this.form.value.featureUnit,
                name: this.form.value.name,
                ggwDevice: this.form.value.ggwDevice,
            })
            .subscribe((featureService) => {
                this.setCurrentEntity(featureService);
                this.setIsCompleted(featureService !== null);
                this.getFeatureService().refreshCurrent();
            })
        ;

    }

    changeGgwDevice($event) {
        if (!isNullOrUndefined($event.value)) {
            this.form.patchValue({name: $event.value.name});
            this.unitRequired = $event.value.unit_required;
            if (this.unitRequired) {
                console.log('form.controls: ', this.form.controls);
                this.form.controls['featureUnit'].setValidators([Validators.required]);
            } else {
                this.form.controls['featureUnit'].setValidators([]);
            }
          this.form.controls['featureUnit'].updateValueAndValidity();
        }
    }

    private updateOptionsList(items: any[]) {
        const optionList = [];
        items.forEach((item) => {
            optionList.push({label: item.name, value: item});
        });
        optionList.sort(sortByLabelFunc);
        return optionList;
    }

    private updateGgwDeviceOptions(items: any[]) {
        this.ggwDeviceOptions = this.updateOptionsList(items);
    }

    private updateFeatureUnitOptions(linkedItems: any[]) {
        const optionList = [];
        linkedItems.forEach((item) => {
            optionList.push({label: item.label, value: linkedResourceToGenericEmbeddedResource(item)});
        });

        this.featureUnitsOptions = optionList;
    }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/ggw-device/components/feature-ggw-device-landing/feature-ggw-device-landing.component.ts